import { apiCall } from "./Interceptor";

const CREATE_CAPACITY_GEN = "/generator/capacity/create";
const UPDATE_CAPACITY_GEN = "/generator/capacity/update";
const DELETE_CAPACITY_GEN = "/generator/capacity/delete";
const GET_CAPACITY_GEN = "/generator/capacity/get";
const GET_ALL_CAPACITY_GEN = "/generator/capacity/getAll";
const UPDATE_CAPACITY_STATUS = "/generator/capacity/updateStatus";
const GET_CAPACITY_EDIT_HISTORY = "/generator/capacity/getHistory"
const GET_ALL_GEN_CAPACITY_FOR_TRADER = "/generator/capacity/getAllForTrader";

const createGeneratorCapacity = async (data) => {
    const response = await apiCall.post(CREATE_CAPACITY_GEN,data);
    return response;
}

const getGeneratorCapacity = async (id) => {
    const response = await apiCall.get(GET_CAPACITY_GEN,id);
    return response;
}

const getAllGeneratorCapacity = async (data) => {
    const response = await apiCall.post(`${GET_ALL_CAPACITY_GEN}?current=true`,data);
    return response;
}

const updateGeneratorCapacity = async (data) => {
    const response = await apiCall.put(UPDATE_CAPACITY_GEN,data);
    return response;
}

const deleteGeneratorCapacity = async (id) => {
    const response = await apiCall.delete(DELETE_CAPACITY_GEN,id);
    return response;
}
const updateCapacityStatus = async (data) => {
    const response = await apiCall.patch(UPDATE_CAPACITY_STATUS,data);
    return response;
}
const getCapacityEditHistoryGenerator = async (id) => {
    const response = await apiCall.get(`${GET_CAPACITY_EDIT_HISTORY}?id=${id}`);
    return response;
}
const getAllGenCapacityForTrader = async (data) => {
    const response = await apiCall.post(GET_ALL_GEN_CAPACITY_FOR_TRADER,data);
    return response;
}
export default {
    createGeneratorCapacity,
    getGeneratorCapacity,
    updateGeneratorCapacity,
    deleteGeneratorCapacity,
    getAllGeneratorCapacity,
    updateCapacityStatus,
    getCapacityEditHistoryGenerator,
    getAllGenCapacityForTrader,
};
